import type { Dispatch, SetStateAction } from 'react';


export interface ITitleContext {
  prefix: string;
  rowCount: number;
  setTitlePrefix: Dispatch<SetStateAction<string>>;
  setTitleRowCount: Dispatch<SetStateAction<number>>;
  resetToDefault?: () => void;
}

export type PageTitleProviderProps = {
  children: React.ReactNode;
};

export type CustomerProps = {
  organizationName: string;
};

export type AgentProps = {
  isEmployee: boolean;
  customerAgents: CustomerProps[];
};

export const RECORD_COUNT_LIMITS = {
  Evaluations: 10_000,
  'Review Queue': 10_000,
};
